import { theme } from '@kvdbil/components';
import styled from 'styled-components';
import Footer from './TabsFooter';
import MainHeader from './MainHeader';
import { Outlet } from 'react-router-dom';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background-color: ${theme.colors.grayscaleToned.light5};
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;

interface Props {
  title: string;
}

const TabsLayout = ({ title }: Props) => {
  return (
    <Container>
      <MainHeader title={title} />
      <Content>
        <Outlet />
      </Content>
      <Footer />
    </Container>
  );
};

export default TabsLayout;
